// Customer A–F grading — admin API client.
// Backend: app/routes/customer_grading_admin.py (/api/customer-grading).

import api from './api';

export interface GradingRunSummary {
  run_id: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  trigger: string;
  rubric_version: string;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
  error: string | null;
  mode: string | null;
  requested_scope: string | null;
  sample_size: number | null;
  customers_considered: number | null;
  items_considered: number | null;
  grades_written: number | null;
  state_transitions: Record<string, number> | null;
}

export interface GradingRunListResponse {
  items: GradingRunSummary[];
  total: number;
  limit: number;
  offset: number;
}

export interface GradingRunDispatchRequest {
  scope?: 'all' | 'triggered';
  sample_size?: number;
}

export interface GradingRunDispatched {
  dispatched: boolean;
  detail: string;
}

export interface PendingGradeChange {
  state_id: string;
  entity_type: string;
  entity_key: string;
  dimension: string;
  status: string;
  effective_grade: string | null;
  proposed_grade: string | null;
  proposed_at: string | null;
  proposed_run_id: string | null;
}

const BASE = '/customer-grading';

export const customerGradingApi = {
  // Queue a manual grading run — full pool or a random sample of N entities.
  run: async (body: GradingRunDispatchRequest): Promise<GradingRunDispatched> => {
    const r = await api.post<GradingRunDispatched>(`${BASE}/run`, body);
    return r.data;
  },

  listRuns: async (limit = 25, offset = 0): Promise<GradingRunListResponse> => {
    const r = await api.get<GradingRunListResponse>(`${BASE}/runs`, {
      params: { limit, offset },
    });
    return r.data;
  },

  listPending: async (): Promise<PendingGradeChange[]> => {
    const r = await api.get<PendingGradeChange[]>(`${BASE}/pending`);
    return r.data;
  },
};
